import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, TrackByFunction } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { IMenuItem } from 'src/app/core/models/menu.model';
import { RoutingService } from 'src/app/core/services/routing.service';

@Component({
  selector: 'app-breadcrumb',
  standalone: true,
  imports: [
    CommonModule,
    MatIconModule
  ],
  templateUrl: './breadcrumb.component.html',
  styleUrl: './breadcrumb.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BreadcrumbComponent {
  @Input() info?: string;

  trees: IMenuItem[];
  icon: string | undefined;

  constructor(
    private routingService: RoutingService,
  ) {
    this.trees = this.routingService.getTreeMenuItems();
    for (const element of this.trees) {
      if (!this.icon) {
        this.icon = element.iconPage ?? element.icon;
      } else {
        this.icon = element.iconPage ?? this.icon;
      }
    }
  }

  trackByMenuItem: TrackByFunction<IMenuItem> = (index, menuItem) => menuItem.name;
}
